import * as React from 'react';
import { Select, Spin } from 'antd';
import { adopt } from 'react-adopt';
import { isString } from 'util';

import SearchProductAccessories from '../../../components/Query/Products/SearchProductAccessories';
import { imageUrl } from '../../../config/config';
import { convertFileToUrl } from '../../../helpers/convertProductImagesToUploadFiles';
import { getImageForVariant } from '../../../helpers/Images/getImageForVariant';
import { getUniqueVariantsByVisualValue } from '../../../helpers/Variants/getUniqueVariantsByVisualValue';
import Option from './components/Option';
import { ILanguageObject } from 'data-layer/src/interfaces/languageObject';

const SearchParams = adopt({
  search: ({ searchQuery, render }) => <SearchProductAccessories searchQuery={searchQuery}>{render}</SearchProductAccessories>,
  selected: ({ variantIds, render }) => <SearchProductAccessories variantIds={variantIds}>{render}</SearchProductAccessories>,
});

export interface IProductSelectProps {
  name: string;
  value?: string[];
  multiple?: boolean;
  required?: boolean;
  // existingAccessories: Array<GQL.IProductVariant>;
  onChange: (e: any) => void;
  language?: string;
}

export interface IAccessory {
  productId: string;
  variantId: string;
  imageUrl: string;
  title: string;
  name: ILanguageObject;
  code: string | null;
  ean: string;
  value: GQL.IAttributeValue;
}

interface IProductSelectState {
  searchQuery: string;
  values: string[];
}

class ProductSelect extends React.Component<IProductSelectProps, IProductSelectState> {
  state = {
    searchQuery: '',
    values: [],
  }

  public static defaultProps = {
    multiple: false,
    required: false,
  };

  public render() {
    const { value, multiple, language } = this.props;
    const { searchQuery } = this.state;

    const valueIds: string[] = [];
    if (value && Array.isArray(value)) {
      value.map(v => valueIds.push(v));
    } else if (value && isString(value)) {
      valueIds.push(value);
    }

    return (
      <div>
        <SearchParams
          variantIds={valueIds}
          searchQuery={searchQuery}
        >
          {({ search: { products: searchProducts }, selected: { products: selectedProducts} }: any) => {
            
            const accessories = this.convertProductsToAccesories([
              ...((searchProducts.searchAccessories || []).edges || []).map((e: GQL.IProductEdge) => e.node),
              ...((selectedProducts.searchAccessories || []).edges || []).map((e: GQL.IProductEdge) => e.node),
            ]);

            return (
              <div>
                <Select
                  mode={multiple === true ? 'multiple' : undefined}
                  showSearch={true}
                  labelInValue={false}
                  placeholder="Select products"
                  notFoundContent={searchProducts.loading ? <Spin size="small" /> : null}
                  filterOption={false}
                  defaultValue={value}
                  onSearch={searchQuery => this.setState({ searchQuery })}
                  onChange={data => {
                    this.onChange(data as any);
                  }}
                  style={{ width: '100%' }}
                >
                  {(accessories ? accessories : []).map(a => {
                    return (
                      <Select.Option
                        title={
                          (a.value !== undefined && a.value.title !== undefined
                            ? a.title + ' - ' + (a.value || {}).title
                            : a.title) + ` (${a.code})`
                        }
                        value={a.variantId}
                        key={a.variantId}
                      >
                        <Option
                          accesory={a}
                          language={language}
                        />
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
            );
          }}
        </SearchParams>
      </div>
    );
  }

  private convertProductsToAccesories(products: Array<GQL.IProduct>): Array<IAccessory> {
    const accessories = new Array<IAccessory>();

    for (const product of products) {
      const tempAccessories = new Array<IAccessory>();

      const uniqueVariants = getUniqueVariantsByVisualValue(product.variants || []);
      for (const uniqueVariant of uniqueVariants) {
        tempAccessories.push({
          productId: product.id,
          variantId: uniqueVariant.id,
          value: (uniqueVariant.attributeValues || [])[0],
          title: product.title,
          name: product.name,
          code: product.sku,
          ean: uniqueVariant.ean,
          imageUrl: convertFileToUrl(
            (getImageForVariant(product, uniqueVariant) || ({} as GQL.IImage)).file,
            imageUrl || ''
          )
        });
      }

      accessories.push(...tempAccessories);
    }

    return accessories;
  }

  private onChange(data: Array<string>) {
    this.setState({
      values: data,
    }, () => {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: this.state.values
        },
      });
    });
  }
}

export default ProductSelect;


// WEBPACK FOOTER //
// ./src/components/Others/ProductSelect/ProductSelect.tsx